export const fluxTutorialsVideos = [
  {
    title: 'FluxPrompt Tutorial: How to create an amazing RFP response',
    videoUrl: 'https://www.youtube.com/watch?v=jn12BIgi1Go',
  },
  {
    title: 'Brief Tour of FluxPrompt',
    videoUrl: 'https://www.youtube.com/watch?v=ccRDCP1j5f4',
  },
  {
    title: 'Large Memory Node + Chat:https',
    videoUrl: 'https://www.youtube.com/watch?v=4IVQlUml8QI',
  },
  {
    title: 'How to create flows on FluxPrompt',
    videoUrl: 'https://www.youtube.com/watch?v=iX1AcTNEGGA',
  },
];

export const fluxBlogs = [
  {
    title: 'Ai Text Generator',
    link:
      'https://intercom.help/enhanced-ai/en/articles/9067270-ai-text-generator',
    previewUrl:
      'https://downloads.intercomcdn.com/i/o/1032869628/0b815d94718bbd277a2ef276/Ai+Text+Generator.png',
    description: `In the rapidly evolving world of artificial intelligence, AI text generators have become invaluable tools for content creation, offering users the ability generate...`,
    author: 'Will Frazier',
  },
  {
    title: 'Ai Image Generator',
    link:
      'https://intercom.help/enhanced-ai/en/articles/9067918-ai-image-generator',
    previewUrl:
      'https://downloads.intercomcdn.com/i/o/1032840979/5e88ec7dad6ebc891953ece8/Ai+Image+Generator.png',
    description: `In today's digital age, AI image generators have become a fascinating tool for creators, designers, and anyone looking to bring their imaginative concepts to life...`,
    author: 'Will Frazier',
  },
  {
    title: 'Ai Image Reader',
    link:
      'https://intercom.help/enhanced-ai/en/articles/9076942-ai-image-reader',
    previewUrl:
      'https://downloads.intercomcdn.com/i/o/1031651890/450596b7bd6605a3a1275d00/Ai+Image+Reader.png',
    description: `AI Image Reader is a powerful tool designed to analyze and interpret images using advanced artificial intelligence. Whether you're a professional looking to...`,
    author: 'Will Frazier',
  },
  {
    title: 'Web Search',
    link: 'https://intercom.help/enhanced-ai/en/articles/9213409-web-search',
    previewUrl:
      'https://downloads.intercomcdn.com/i/o/1024766167/55a259434c3eccfd190ec6ae/Web+Search.png',
    description: `How to Use the Web Search Tool: A Comprehensive Guide`,
    author: 'Will Frazier',
  },
];
